var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlancherSurSousSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.13 20.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #48a777;\n      }\n\n      .cls-2 {\n        fill: #45a674;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.29,0c.25,0,.5,0,.76,0v18.8s77.02,0,77.02,0V0h1.83C81.09,0,81.13,0,81.13,0v20.47H0V0C.43.01.86,0,1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.93,16.11h36.68v-3.7h6.26v-3.33h6.36v-3.24s0,0,.16,0h6.09v-3.33h6.26V.1c1.63,0,0,.01.12.01.53-.01,1.81-.01,2.25-.01v3.98s-.15,0-.16,0h-6.31v3.33h-6.26v3.15h-6.46s-.01,0-.01.32v3.1h-6.15v2.13h30.31V.19s0-.11,0-.19h2.38v17.68H3.67V0h1.89S5.83,0,5.93,0v16.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlancherSurSousSol);
export default __webpack_public_path__ + "static/media/plancher-sur-sous-sol.639603f07bc84e90c3dd9f97107bf73d.svg";
export { ForwardRef as ReactComponent };